import { LocationIds } from "@src/components/shared-containers/LocationSelectorDialog/types";
import { useMemo, useState } from "react";

import LocationContext, { LocationDetailsType } from "./locationContext";

const LocationProvider = (props: { children: React.ReactNode }) => {
  const { children } = props;

  const locationidsString = localStorage.getItem("locationIds");
  const dateString = localStorage.getItem("date");
  let InitialLocationDetailState = {
    property: "",
    revenueCenter: "",
    store: "",
    date: "",
  };

  if (locationidsString !== null && dateString !== null) {
    const {
      property,
      store_id: storeId,
      rvc_id: rvcId,
    }: LocationIds = JSON.parse(locationidsString);
    const localDate: string = JSON.parse(dateString);

    InitialLocationDetailState = {
      property: property || "",
      revenueCenter: rvcId || "",
      store: storeId || "",
      date: localDate || "",
    };
  }

  const [locationState, locationSetState] = useState<LocationDetailsType>(
    InitialLocationDetailState
  );

  const stateValue = useMemo(
    () => [{ locationState, locationSetState }],
    [locationState, locationSetState]
  );

  return (
    <LocationContext.Provider value={stateValue}>
      {children}
    </LocationContext.Provider>
  );
};

export default LocationProvider;
